<script>
import i18n from "@/i18n";
import {TieredMenu} from "primevue";
import {mapActions} from "pinia";
import {userSettingStore} from "@/store/userSettingStore";
import {baseLoaderStore} from "@/store/baseLoaderStore";
import {successMessageStore} from "@/store/successMessageStore";
export default {
  name: "BasePrivacySwitcher",
  props: {
    privacyType: {
      type: String,
      required: true
    },
    privacyValue: {
      type: String,
      required: true
    }
  },
  components: {
    TieredMenu
  },
  data() {
    return {
      items: [
        {
          label: i18n.global.t('privacy.private'),
          value: 'PRIVATE',
          command: (e) => {
            this.setPrivacy(this.privacyType, e.item.value);
          }
        },
        {
          label: i18n.global.t('privacy.public'),
          value: 'PUBLIC',
          command: (e) => {
            this.setPrivacy(this.privacyType, e.item.value);
          }
        }
      ]
    }
  },
  computed: {
    iconClass() {
      return this.privacyValue;
    },
    tooltipText() {
      return this.items.filter(item => item.value === this.privacyValue)[0].label
    }
  },
  methods: {
    ...mapActions(userSettingStore,[
      'getUserSettings',
      'updateUserSettingAction'
    ]),
    ...mapActions(baseLoaderStore, [
      'showBaseLoader',
      'hideBaseLoader'
    ]),
    ...mapActions(successMessageStore, [
      'showSuccessMessage'
    ]),
    toggle(event) {
      this.$refs.menu.toggle(event);
    },
    setPrivacy(type, val) {
      if (this.privacyValue === val) return;

      this.showBaseLoader();
      this.updateUserSettingAction(type, val).then(()=> {
        this.getUserSettings().then(()=> {
          this.hideBaseLoader();
          this.showSuccessMessage(i18n.global.t('privacy.privacyUpdatedMsg'), 500);
        });
      })
    }
  }
}
</script>

<template>
<div class="privacy-switcher">
  <div class="privacy-switcher__icon"
       :class="iconClass"
       @click="toggle"
       v-tooltip.top="tooltipText"
  ></div>
  <TieredMenu ref="menu" id="overlay_tmenu" :model="items" popup />
</div>
</template>

<style lang="scss">
.privacy-switcher {
  cursor: pointer;
  &__icon {
    width: 18px;
    height: 18px;
    cursor: pointer;
    filter: grayscale(100%);

    &.PRIVATE {
      background: url("~@/assets/img/opinion/PRIVATE.svg") no-repeat center;
      background-size: 12px;
    }
    &.PUBLIC {
      background: url("~@/assets/img/opinion/PUBLIC.svg") no-repeat center;
      background-size: 12px;
    }
  }
  &:hover {
    .privacy-switcher__icon {
      filter: none;
    }
  }
}

.p-tieredmenu {
  margin-top: 5px !important;
  border-radius: 5px !important;

  .p-tieredmenu-item {
    .p-tieredmenu-item-content {
      background: transparent !important;
      &:hover {
        background: #ebebeb !important;
      }

      .p-tieredmenu-item-link {
        color: #7835a6 !important;
      }
    }
  }
}

</style>